import { API_URL } from './Api';

export const API_URN = '/v1/usuarios';

export function ENDERECOS_PESQUISA(id) {
  return {
    url: `${API_URL}${API_URN}/${id}/enderecos`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function ENDERECOS_EXCLUIR(idCorreios, idEndereco) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/enderecos/${idEndereco}`,
    options: {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function ENDERECOS_ALTERAR(idCorreios,idEndereco, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/enderecos/${idEndereco}`,
    options: {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ENDERECOS_INCLUIR(idCorreios, body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/enderecos`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function ENDERECOS_TORNAR_PRINCIPAL(idCorreios, idEndereco) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}/enderecos/tornarPrincipal/${idEndereco}`,
    options: {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function ENDERECOS_BUSCA_PAIS(nome) {
  return {
    url: `${API_URL}${API_URN}/enderecos/pais?nome=${nome}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}

export function ENDERECOS_BUSCA_CEP(cep) {
  return {
    url: `${API_URL}${API_URN}/enderecos/cep/${cep}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}